import { gql } from 'apollo-angular'

export const ACCEPT_ORGANIZATION_RESELLER_REQUEST = gql`
  mutation AcceptOrganizationResellerRequest(
    $data: AcceptOrganizationResellerRequestInput!
  ) {
    acceptOrganizationResellerRequest(data: $data) {
      success
    }
  }
`
